class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      
      var thisType = this.dataset.type;
      var thisTitle = this.dataset.title;
      setTimeout(function() {
        if(thisType != 'Addon'){
          var values = '{';
          $('.cart-remove').each(function(i, obj) {
            var dataType = $(this).data('type');
            var dataExtraProduct = $(this).data('extra-product');
            if(dataType == 'Addon' && dataExtraProduct == thisTitle){
              console.log(dataExtraProduct);
              console.log(thisTitle);
              var dataVariantID = $(this).data('variant-id');
              var dataKey = $(this).data('key');
              //values+= '"'+dataVariantID+'":0,';
              values+= '"'+dataKey+'":0,';
            }
          });
          values = values.slice(0, -1);
          values+= '}';
          if(values != '{}'){
            var values_json = $.parseJSON(values);
            console.log(values_json);
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data:	{
                updates: values_json
              },
              dataType: 'json',
              error: function(){
                alert('Error!');
              },
              success: function(){
                window.location.href = "/cart";
              }
            });
          }
        }
      }, 1000);
      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartAddItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var checkboxChecked = $('#fast-turnaround').val(); 
      if(checkboxChecked == 'Yes'){
        var index = $('.item-40770175434907').data('index');
        this.closest('cart-items').updateQuantity(index, 0, document.activeElement.getAttribute('name'));
      }else{
        this.closest('cart-items').addItem(40770175434907, 1);
      }
    });
  }
}

customElements.define('cart-add-item', CartAddItem);

class CartAddItemExtra extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var checkboxCheckedScreen = $('#screen-recording').val(); 
      if(checkboxCheckedScreen == 'Yes'){
        var index_2 = $('.item-47134693327100').data('index');
        this.closest('cart-items').updateQuantity(index_2, 0, document.activeElement.getAttribute('name'));
      }else{
        this.closest('cart-items').addItem(47134693327100, 1);
      }
    });
  }
}

customElements.define('cart-add-item-extra', CartAddItemExtra);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.clearCart();
  }

  onChange(event) {
    if(event.target.value == 0){
      event.target.value = 1;
    }else{
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }
  
  addItem(id, quantity) {
   this.enableLoading();
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }
  
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

  clearCart() {
    var check_main_product = $('#cart-items').data('check-main-product');
    console.log(check_main_product);
    console.log($("#cart-items.is-empty").length);
    if ($("#cart-items.is-empty").length == 0 && check_main_product == false) {
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
          setTimeout(function() {window.location.href = "/cart";}, 1000);
        },
        error: function(XMLHttpRequest, textStatus) {
          alert('Error!');
        }
      });
  
    }
  }
  
}

customElements.define('cart-items', CartItems);
